import propTypes from 'vue-types';
import { ExtractPropTypes, PropType } from 'vue';
import { ColorFormat } from './utils/color';
import { Placement, SupportLang } from './utils/type';

export const colorPickerProps = {
  // 是否以控件形式展示
  isWidget: propTypes.bool.def(false),
  // 方块或是chrome 形式展现
  pickerType: propTypes.oneOf(['tk', 'chrome']).def('tk'),
  // 展示形状 circle: 圆形 , square: 方形
  shape: propTypes.oneOf(['circle', 'square']).def('square'),
  // 纯色颜色值
  // pureColor: {
  //   type: [String, Object] as PropType<ColorInputWithoutInstance>,
  //   default: '#000000',
  // },
  // // 渐变色颜色值
  // gradientColor: propTypes.string.def(
  //   'linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(0, 0, 0, 1) 100%)',
  // ),
  modelValue: {
    type: String as PropType<string>,
    required: true,
    default: '#ffffff',
  },
  // 颜色格式
  // format: 'rgba', // 'hsla' || 'rgba' || 'hex' || 'hsl' || 'rgb'
  format: {
    type: String as PropType<ColorFormat>,
    default: 'rgb',
  },
  // 关闭Alpha
  disableAlpha: propTypes.bool.def(false),
  // 关闭历史记录
  disableHistory: propTypes.bool.def(false),
  // 是否圆形显示历史记录
  roundHistory: propTypes.bool.def(false),
  // 纯色/渐变色/都展示
  useType: propTypes.oneOf(['pure', 'gradient', 'both']).def('pure'),
  // 默认激活纯色或渐变色
  activeKey: propTypes.oneOf(['pure', 'gradient']).def('pure'),
  // 展示语言
  lang: {
    type: String as PropType<SupportLang>,
    default: 'ZH-cn',
  },
  // 显示位置
  placement: {
    type: String as PropType<Placement>,
    default: 'auto',
  },
  zIndex: propTypes.number.def(9999),
  /**
   * 默认颜色，modelValue为空时，默认显示的颜色
   */
  defPureColor: {
    type: String as PropType<string>,
    default: '',
  },
};

export type ColorPickerProps = ExtractPropTypes<typeof colorPickerProps>;
